<template>
  <div>
    <v-navigation-drawer v-model="drawer" temporary app right>
      <v-list nav dense>
        <v-list-item-group active-class=" text--primary-4">
          <v-list-item @click="$vuetify.goTo(refs.product)">
            <v-list-item-title>Producto</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$vuetify.goTo(refs.pricing)">
            <v-list-item-title>Precios</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$vuetify.goTo(refs.contactUs)">
            <v-list-item-title>Contáctanos</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title @click="goTo(urls.merloCodeAdmin)">Iniciar sesión</v-list-item-title>
          </v-list-item>

          <v-list-item class="justify-center mt-12">
            <v-btn outlined color="primary" @click="goTo(urls.merloCodeSignUp)">
              <!-- <v-btn href="" target="_blank" color="primary" elevation="0"> -->
              Regístrate
              <!-- </v-btn> -->
            </v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="background" class="px-md-6 px-lg-6 px-xl-6" flat height="125px">
      <v-row align="center">
        <v-img
          alt="Merlo Logo"
          class="shrink mr-2 mb-1"
          :src="require('../assets/MerloLogoLight.png')"
          transition="scale-transition"
          width="150px"
        />

        <v-btn
          class="hidden-sm-and-down mx-2 body-1 font-weight-bold"
          @click="$vuetify.goTo(refs.product)"
          text
        >
          <span>Producto</span>
        </v-btn>

        <v-btn
          class="hidden-sm-and-down mx-2 body-1 font-weight-bold"
          @click="$vuetify.goTo(refs.pricing)"
          text
        >
          <span>Precios</span>
        </v-btn>

        <v-btn
          class="hidden-sm-and-down mx-2 body-1 font-weight-bold"
          @click="$vuetify.goTo(refs.contactUs)"
          text
        >
          <span>Contáctanos</span>
        </v-btn>
        <v-spacer />

        <v-btn class="hidden-sm-and-down mx-4" href target="_blank" text>
          <span @click="goTo(urls.merloCodeAdmin)">Iniciar sesión</span>
        </v-btn>

        <v-btn
          class="hidden-sm-and-down"
          href
          target="_blank"
          color="primary"
          elevation="0"
          outlined
        >
          <span @click="goTo(urls.merloCodeSignUp)">Regístrate</span>
        </v-btn>
        <v-app-bar-nav-icon class="hidden-md-and-up" @click.stop="drawer = !drawer" />
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "AppBar",
  data: () => ({
    drawer: false,
    urls: {
      merloCodeAdmin: "https://admin.merlocode.com",
      merloCodeSignUp: "https://admin.merlocode.com/signup"
    },
    refs: {
      product: "#product",
      pricing: "#pricing",
      contactUs: "#contactUs"
    }
  }),

  methods: {
    goTo(url) {
      console.log(`go to ${url}`);
      window.document.location = url;
    },

    scrollTo(refId) {
      this.$nextTick(() => {
        console.log(this.$refs[refId]);
        this.$gtag.event("inLanding", {
          refId: refId
        });
        this.$refs[refId].scrollTop = 0;
        // this.$refs[refId].scrollTop = 0;
      });
    }
  }
};
</script>

<style></style>
